import { render, staticRenderFns } from "./telegramForm.vue?vue&type=template&id=62b02903&scoped=true"
import script from "./telegramForm.vue?vue&type=script&lang=js"
export * from "./telegramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b02903",
  null
  
)

export default component.exports